import React from "react"
import { Button } from "reactstrap"
import { formatDate } from "./utils"
import { AUDIT_STATUS_META } from "./data"
import StatusBadge from "./StatusBadge"

const AuditDrawer = ({ open, row, onClose, onRetry, canEdit }) => {
  if (!open || !row) return null

  const hasReason = row.status === "Failed" || row.status === "Pending"

  const fields = [
    { label: "Username", value: row.username },
    { label: "Player ID", value: row.playerId },
    { label: "Affiliate", value: row.affiliate },
    { label: "Referral code", value: row.referralCode },
    { label: "Campaign", value: row.campaign },
    { label: "Award date", value: formatDate(row.awardDate) },
    { label: "Bonus status", value: row.status },
  ]

  return (
    <>
      <style>{`
        @keyframes abScrim { from { opacity: 0 } to { opacity: 1 } }
        @keyframes abDrawer { from { transform: translateX(100%) } to { transform: translateX(0) } }
      `}</style>
      <div style={{ position: "fixed", inset: 0, zIndex: 1050, display: "flex", justifyContent: "flex-end" }}>
        <div
          onClick={onClose}
          style={{ position: "absolute", inset: 0, background: "rgba(27,36,49,.42)", animation: "abScrim .2s ease both" }}
        />
        <div
          className="bg-white shadow"
          style={{
            position: "relative",
            width: 420,
            maxWidth: "90vw",
            height: "100%",
            animation: "abDrawer .28s cubic-bezier(.2,.8,.2,1) both",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="d-flex align-items-start justify-content-between p-3 border-bottom">
            <div>
              <div className="text-muted text-uppercase font-size-11 fw-semibold">Bonus award</div>
              <h5 className="mt-1 mb-0">{row.player}</h5>
              <div className="text-muted font-size-12 mt-1">
                {row.playerId} · {row.username}
              </div>
            </div>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
              <i className="mdi mdi-close" />
            </button>
          </div>
          <div className="flex-grow-1 overflow-auto p-3">
            <div className="d-flex align-items-center bg-light rounded p-3 mb-3">
              <div className="fs-4 fw-bold">{row.amount}</div>
              <div className="ms-auto">
                <StatusBadge status={row.status} meta={AUDIT_STATUS_META} />
              </div>
            </div>
            {fields.map(f => (
              <div key={f.label} className="d-flex justify-content-between py-2 border-bottom">
                <span className="text-muted font-size-12">{f.label}</span>
                <span className="font-size-12 fw-medium text-end">{f.value}</span>
              </div>
            ))}
            {hasReason && row.reason && (
              <div className="mt-3 p-3 rounded" style={{ background: "#fde8e8", border: "1px solid #f5c2c2" }}>
                <div className="fw-bold text-danger font-size-12 mb-1">Failure reason</div>
                <p className="mb-0 font-size-12" style={{ color: "#a5514c" }}>
                  {row.reason}
                </p>
              </div>
            )}
          </div>
          <div className="d-flex gap-2 p-3 border-top">
            <Button color="light" className="flex-fill" onClick={onClose}>
              Close
            </Button>
            {canEdit && hasReason && (
              <Button color="primary" className="flex-fill" onClick={onRetry}>
                Retry award
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default AuditDrawer
